import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GlobalLoadingService {
  // Signal, damit OnPush-Templates auch Änderungen nach await/Socket-Events mitbekommen
  private readonly _loading = signal(false);

  public get loading(): boolean {
    return this._loading();
  }

  public set loading(value: boolean) {
    this._loading.set(value);
  }
}
